
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playgrounds",
      function () {
        return require("private-next-pages/playgrounds/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playgrounds"])
      });
    }
  